export default {
  title: 'Report MRR',
  fields: {
    name: 'Nome',
    area: 'Area',
    mrr: 'MRR (netto)',
  },
  buttons: {
    download_report: 'Scarica report',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito, aggiorna la pagina',
  },
};
